import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSectionHeadersvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={15} height={56} fill='currentColor' {...props}>
    <mask id='SectionHeadersvg_svg__a' fill='#fff'>
      <path d='M0 6a6 6 0 0 1 6-6h3a6 6 0 0 1 6 6v44a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z' />
    </mask>
    <path fill='none' d='M0 6a6 6 0 0 1 6-6h3a6 6 0 0 1 6 6v44a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z' />
    <path
      fill='currentColor'
      d='M0 0h15zm15 56H0zM0 56V0zM9 0c5.523 0 10 4.477 10 10v36c0 5.523-4.477 10-10 10 1.105 0 2-2.686 2-6V6c0-3.314-.895-6-2-6'
      mask='url(#SectionHeadersvg_svg__a)'
    />
  </svg>
);
export default SvgSectionHeadersvg;
